import http from '../utils/http';
import qs from 'qs' 

const customerMaterial = {
    /**
     * 音乐分组列表
     */
    getMusicGroup(options = {}, config = {}) {
        return http.get('/musicGroup/getMusicGroupList', options, {
            ...config
        })
    },

    /**
     * 添加音乐分组
     * @param {Object} options
     * @returns Promise
     */
    addFileGroup(options = {}, config = {}) {
        return http.post('/musicGroup/addMusicGroup', options, {
            ...config
        })
    },

    /**
     * 分组重命名
     * @param {Object} options
     * @returns Promise
     */
    editGroupName(options = {}, config = {}) {
        return http.post('/musicGroup/editMusicGroup', options, {
            ...config
        })
    },

    /**
     * 删除音乐分组
     * @param {Object} options
     * @returns Promise
     */
    deletebyMusicGroupIds(musicGroupIds='') {
        return http.delete(`/musicGroup/deleteByMusicGroupId?musicGroupIds=${musicGroupIds}`)
    },

    /**
     * 分页获取音乐列表
     * @param {Object} options
     * @returns Promise
     */
    getMusicByPage(options = {}, config = {}) {
        return http.get('/music/getMusicByPage', options, {
            ...config
        })
    },

    /**
     * 客户新增本地音乐
     * @param {Object} options
     * @returns Promise
     */
    addLocalMusic(options = {}, config = {}) {
        return http.post('/music/addLocalMusic', qs.stringify(options), {
            ...config,
             headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            }
        })
    },
    /**
     * 客户新增素材库音乐
     * @param {Object} options
     * @returns Promise
     */
    addFileMusic(options = {}, config = {}) {
        return http.post('/music/addFileMusic', qs.stringify(options), {
            ...config,
             headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            }
        })
    },

    /**
     * 修改音乐名称
     */
    updateMusicName(options = {}, config = {}) {
        return http.post('/music/updateMusicName', options, {
            ...config
        })
    },
    /**
     * 修改音乐分组
     */
    updateMusicGroup(options = {}, config = {}) {
        return http.post('/music/updateMusicGroup', options, {
            ...config
        })
    },
    /**
     * 删除音乐文件
     * @param {Object} options
     * @returns Promise
     */
    deleteMusicById(musicId='') {
        return http.delete(`/music/deleteMusicById?musicId=${musicId}`)
    }
}

export default customerMaterial;
